import { isUserConnectedToWallet } from 'components/pages/Banks/Wallet/helpers';
import type { Connector } from 'types/transactions.types';
import useGetConnectors from './useGetConnectors';

const useHasAccountableBanking = () => {
  const { data: connectors } = useGetConnectors();

  return isUserConnectedToWallet(connectors as Connector[]);
};

export default useHasAccountableBanking;
